import { render } from "./DesignExpress.vue?vue&type=template&id=0af0dc2b"
import script from "./DesignExpress.vue?vue&type=script&lang=js"
export * from "./DesignExpress.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__